"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyStatusSection = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TabLayout_1 = require("../../../base/layout/TabLayout");
const common_1 = require("../../../../common");
const ReportTable_1 = require("./ReportTable");
const Colors_1 = require("../../../../Colors");
const WeeklyStatusSectionStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ $isMobile }) => ($isMobile ? '20px' : '28px')};

	.section-mobile-style {
		padding: ${({ $isMobile }) => ($isMobile ? '0 16px' : '0')};
	}

	.section-title {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '16px' : $isTablet ? '17px' : '18px')};
		line-height: 140%;
		font-weight: 700;
	}

	.section-title-detail {
		padding: ${({ $isMobile }) => ($isMobile ? '0 16px' : '0')};
	}

	.summary-panel,
	.learning-card {
		border: 1px solid #e4e6ea;
		border-radius: 16px;
		background: #fff;
	}

	.summary-panel {
		display: flex;
		overflow: hidden;
	}

	.summary-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: ${({ $isMobile }) => ($isMobile ? '12px' : '24px')};
		padding: ${({ $isMobile }) => ($isMobile ? '22px 12px' : '28px 24px')};
		text-align: center;
		position: relative;
	}

	.summary-item + .summary-item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 1px;
		height: ${({ $isMobile }) => ($isMobile ? '36px' : '50px')};
		background: #eceef2;
	}

	.summary-label {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '17px')};
		line-height: 145%;
		font-weight: 700;
	}

	.summary-value {
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '17px' : $isTablet ? '24px' : '28px')};
		line-height: 1.2;
		font-weight: 700;
		white-space: nowrap;
	}

	.learning-list {
		display: flex;
		flex-wrap: ${({ $isMobile }) => ($isMobile ? 'wrap' : 'nowrap')};
		gap: 16px;
	}

	.learning-card {
		flex: ${({ $isMobile }) => ($isMobile ? '1 1 100%' : '1 1 calc((100% - 32px) / 3)')};
		min-width: 0;
		padding: ${({ $isMobile }) => ($isMobile ? '20px 18px' : '20px 24px')};
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.learning-label {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '16px' : $isTablet ? '17px' : '18px')};
		line-height: 145%;
		font-weight: 700;
	}

	.learning-rate {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '20px' : $isTablet ? '24px' : '30px')};
		line-height: 1;
		font-weight: 800;
	}

	.learning-rate-row {
		display: flex;
		align-items: center;
		gap: ${({ $isMobile, $isTablet }) => ($isMobile ? '16px' : $isTablet ? '14px' : '18px')};
	}

	.learning-rate-row .learning-rate {
		min-width: ${({ $isMobile, $isTablet }) => ($isMobile ? '50px' : $isTablet ? '65px' : '102px')};
		flex-shrink: 0;
	}

	.learning-graph {
		flex: 1;
		min-width: 0;
	}

	.detail-wrap {
		padding-top: ${({ $isMobile }) => ($isMobile ? '10px' : '16px')};
		border-top: ${({ $isMobile }) => (!$isMobile ? '1px solid #e4e6ea' : 'none')};
		display: flex;
		flex-direction: column;
		gap: 18px;
	}

	.report-tab-layout {
		width: 100%;
		gap: ${({ $isMobile, $isTablet }) => ($isMobile || $isTablet ? '10px' : '14px')};
		align-items: flex-start;
	}

	.report-tab-list {
		padding: 4px;
		display: inline-flex;
		width: ${({ $isMobile }) => ($isMobile ? '100%' : 'fit-content')};
		max-width: 100%;
		justify-content: flex-start;
		margin: ${({ $isMobile }) => ($isMobile ? '0 16px' : '0')};
	}

	.report-tab-content {
		width: 100%;
		padding: ${({ $isMobile }) => ($isMobile ? '0 16px' : '0')};
	}

	.filter-row {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;
		width: ${({ $isMobile }) => ($isMobile ? '100%' : 'auto')};
		background-color: ${({ $isMobile }) => ($isMobile ? '#f3f5f8' : 'transparent')};
		padding: ${({ $isMobile }) => ($isMobile ? '12px 14px' : '0')};
	}

	.filter-row .search-bar {
		min-width: ${({ $isMobile }) => ($isMobile ? '0' : '240px')};
		flex: ${({ $isMobile }) => ($isMobile ? '1 1 180px' : 'unset')};
	}

	.refund-checkbox {
		display: inline-flex;
		align-items: center;
		font-size: ${({ $isMobile }) => ($isMobile ? '15px' : '16px')};
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
	}

	.refund-checkbox .checkbox-item {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.refund-checkbox .checkbox-item span {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '15px' : '16px')};
		line-height: 150%;
	}

	.table-wrap {
		width: 100%;
	}

`;
const detailTabLabels = {
    attendance: '출결',
    test: '테스트',
    assignment: '과제',
};
const statusOptions = {
    attendance: [
        { id: 'attend', title: '출석' },
        { id: 'late', title: '지각' },
        { id: 'absent', title: '결석' },
    ],
    test: [
        { id: 'submit', title: '응시' },
        { id: 'not-submit', title: '미응시' },
    ],
    assignment: [
        { id: 'submit', title: '응시' },
        { id: 'not-submit', title: '미응시' },
    ],
};
const renderEmpty = react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } }, "\uC870\uAC74\uC5D0 \uB9DE\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.");
const getStatusTitle = (segment, selectedList) => {
    const allItems = statusOptions[segment];
    const label = segment === 'attendance' ? '출결상태' : '응시상태';
    if (selectedList.length === allItems.length) {
        return `${label} (전체)`;
    }
    return `${label} (${selectedList.length})`;
};
exports.WeeklyStatusSection = react_1.default.memo(({ weeklyData, detailLoading = false, activeSegment, onChangeSegment, selectedStatuses, onChangeSelectedStatuses, includeRefunded, onChangeIncludeRefunded, keyword, onChangeKeyword, isMobile, isTablet, isDesktop, onScoreClick, }) => {
    // SearchBar 는 keyword 를 매 keystroke 마다 onChangeKeyword 로 올려보내고, 그 값이 다시
    // defaultSearchContent prop 으로 내려오면 SearchBar 내부 effect 가 native input.value 를
    // 강제로 재설정한다. 이 echo 가 한글 조합(IME) 을 매 글자마다 끊어 타이핑이 떨리는
    // 현상을 만들었다. 마운트 시점의 keyword(탭 전환 후 복귀 시 검색어 유지용) 만 1회
    // 전달하고, 이후 타이핑에 대해서는 defaultSearchContent 를 갱신하지 않아 echo 를 끊는다.
    const initialKeywordRef = react_1.default.useRef(keyword);
    const getRowsBySegment = (segment) => {
        if (segment === 'attendance')
            return weeklyData.attendanceRows;
        return segment === 'test' ? weeklyData.testRows : weeklyData.assignmentRows;
    };
    const selectedStatusItems = react_1.default.useMemo(() => statusOptions[activeSegment].filter(item => selectedStatuses.includes(item.id)), [activeSegment, selectedStatuses]);
    const setSelectedStatusItems = (nextItems) => {
        onChangeSelectedStatuses(activeSegment, nextItems.map(item => item.id));
    };
    const renderSegmentContent = (segment) => {
        const segmentRows = getRowsBySegment(segment).filter(row => {
            const normalizedKeyword = keyword.trim().toLowerCase();
            if (!includeRefunded && row.refunded) {
                return false;
            }
            if (!selectedStatuses.includes(row.status)) {
                return false;
            }
            if (!normalizedKeyword) {
                return true;
            }
            if (segment === 'attendance' &&
                row.className.toLowerCase().includes(normalizedKeyword)) {
                return true;
            }
            return (row.studentName.toLowerCase().includes(normalizedKeyword) ||
                row.studentId.toLowerCase().includes(normalizedKeyword));
        });
        return (react_1.default.createElement("div", { className: "table-wrap" },
            react_1.default.createElement(ReportTable_1.ReportTable, { variant: "weekly", segment: segment, data: segmentRows, renderEmpty: renderEmpty, onScoreClick: onScoreClick, loading: detailLoading })));
    };
    // TabLayout 은 keepMounted 없이(기본값 false) activeTab.content 만 사용하므로 비활성 세그먼트의
    // content 는 화면에 그려지지 않고 버려진다. 그런데도 기존엔 3개 세그먼트 전부에 대해
    // renderSegmentContent(필터링 + ReportTable JSX 생성)을 매 keystroke 마다 호출해
    // 실제 화면에 쓰이는 것의 3배를 계산하고 있었다 — 이게 타이핑할 때 검색이 느려지던 원인.
    // (게다가 selectedStatuses 는 activeSegment 기준 하나뿐이라 비활성 세그먼트엔 애초에 값도
    // 틀렸음 — 안 쓰이니 드러나지 않았을 뿐.) 활성 세그먼트만 계산하도록 축소.
    const detailTabs = ['attendance', 'test', 'assignment'].map(segment => ({
        id: segment,
        title: detailTabLabels[segment],
        content: segment === activeSegment ? renderSegmentContent(segment) : null,
    }));
    const handleSearch = (value) => {
        onChangeKeyword(value.keyword || '');
    };
    return (react_1.default.createElement(WeeklyStatusSectionStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        react_1.default.createElement("section", { className: "section-mobile-style" },
            react_1.default.createElement("div", { className: "section-title" }, "\uC778\uC6D0 \uD604\uD669"),
            react_1.default.createElement("div", { className: "summary-panel" }, weeklyData.peopleSummary.map(item => (react_1.default.createElement("div", { key: item.id, className: "summary-item" },
                react_1.default.createElement("div", { className: "summary-label" }, item.label),
                react_1.default.createElement("div", { className: "summary-value" }, `${item.value}${item.unit || ''}`)))))),
        react_1.default.createElement("section", { className: "section-mobile-style" },
            react_1.default.createElement("div", { className: "section-title" }, "\uD559\uC2B5 \uD604\uD669"),
            react_1.default.createElement("div", { className: "learning-list" }, weeklyData.learningSummary.map(item => (react_1.default.createElement("div", { key: item.id, className: "learning-card" },
                react_1.default.createElement("div", { className: "learning-label" }, item.label),
                react_1.default.createElement("div", { className: "learning-rate-row" },
                    react_1.default.createElement("div", { className: "learning-rate" }, `${item.value}%`),
                    react_1.default.createElement(common_1.SimpleBarGraph, { className: "learning-graph", value: item.value, max: 100, fillColor: "#8bc7d6", trackColor: "#f0f2f5", height: 28, borderRadius: 0 }))))))),
        react_1.default.createElement("section", { className: "detail-wrap" },
            react_1.default.createElement("div", { className: "section-title section-title-detail" }, "\uC0C1\uC138 \uB0B4\uC5ED"),
            react_1.default.createElement(TabLayout_1.TabLayout, { className: "report-tab-layout", tabListClassName: "report-tab-list", contentClassName: "report-tab-content", tabs: detailTabs, activeTabId: activeSegment, onTabChange: tabId => onChangeSegment(tabId), equalButtonWidth: true, buttonSize: "md", headerRight: react_1.default.createElement("div", { className: "filter-row" },
                    !isMobile && (react_1.default.createElement("div", { className: "refund-checkbox" },
                        react_1.default.createElement(common_1.CheckBoxElement, { id: "include-refunded", title: "\uD658\uBD88 \uD3EC\uD568", checked: includeRefunded, handlerCheck: (_, checked) => onChangeIncludeRefunded(checked), iconSize: 20 }))),
                    react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: selectedStatusItems[0] || statusOptions[activeSegment][0], list: statusOptions[activeSegment], setDropValue: () => undefined, multiSelect: true, selectedList: selectedStatusItems, setSelectedList: setSelectedStatusItems, showCheckbox: true, renderTitleText: selected => getStatusTitle(activeSegment, selected), styles: {
                            dropWrap: {
                                width: isMobile ? '100%' : 178,
                            },
                            itemWrap: {
                                top: 50,
                            },
                        } }),
                    react_1.default.createElement(common_1.SearchBar, { className: isMobile ? 'search-bar-mobile' : 'search-bar-qna', filterData: "keyword", defaultSearchContent: initialKeywordRef.current, handlerFilterList: handleSearch, isIconHide: true }),
                    isMobile && (react_1.default.createElement("div", { className: "refund-checkbox" },
                        react_1.default.createElement(common_1.CheckBoxElement, { id: "include-refunded", title: "\uD658\uBD88 \uD3EC\uD568", checked: includeRefunded, handlerCheck: (_, checked) => onChangeIncludeRefunded(checked), iconSize: 20 })))) }))));
});
